import { render, staticRenderFns } from "./novel_generator_template.vue?vue&type=template&id=ffcb6fd8"
import script from "./novel_generator_template.vue?vue&type=script&lang=js"
export * from "./novel_generator_template.vue?vue&type=script&lang=js"
import style0 from "./novel_generator_template.vue?vue&type=style&index=0&id=ffcb6fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports